import { Injectable, Injector, Optional, forwardRef } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AppConstants } from "../constants/app.contants";
import { Utils } from "../helpers/utils.helper";
import { User } from "../models/app.models";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    //#region properties

    //#region private
    private _token: string = '';
    private _user: User | null = null;
    private _email: string = ''; 
    private _refreshToken: string = '';
    public registrationData: any; // Store all registration data

    //#endregion

    //#region public
    //#endregion

    //#endregion

    //#region ctor
    private _injector?: Injector;
    constructor(
        private _jwtHelper: JwtHelperService,
        @Optional() injector?: Injector
    ) {
        this._injector = injector;
    }
    //#endregion
    
    // Set injector from outside if needed (to avoid circular dependency)
    setInjector(injector: Injector): void {
        this._injector = injector;
    }

    
    //#region setters

    setRegistrationData(data: any) {
        this.registrationData = data;
      }
    
    


    public set token(value: string) {
       
        this._token = value;
    }
    public set user(value: User | null) {
        this._user = value;
    }
    //#endregion
    public set email(value: string) {
        this._email = value;
    }
    //#region getters

    clearRegistrationData() {
        this.registrationData = null;
      }
      
      getRegistrationData() {
        return this.registrationData;
      }

    public get token() {
        return this._token;
    }
    public get user() {

        return this._user;
    }
    public get email() {
        return this._email;
    }
    public get refreshToken() { return this._refreshToken; }
    public get isUserAuthenticatedOnNas() {
        return !Utils.IsNullOrUndefined(this._token) && !Utils.IsNullOrUndefined(this._user) && !this._jwtHelper.isTokenExpired(this._token);
    }
    public get isUserAuthenticated() {
        return !Utils.IsNullOrUndefined(this._token) && !Utils.IsNullOrUndefined(this._user) && !this._jwtHelper.isTokenExpired(this._token) && !Utils.IsNullOrWhiteSpace(this._user?.Id);
    }
    //#endregion

    //#region private actions
    private mapTokenToUser(entity: any) {

        this._user = new User({ 
            Id: entity[AppConstants.CLAIMS.UserId],
            FullName: entity[AppConstants.CLAIMS.FullName],
            EmailAddress: entity[AppConstants.CLAIMS.EmailAddress],
            MobilePhone: entity[AppConstants.CLAIMS.MobilePhone],
            Role: entity[AppConstants.CLAIMS.Role] || entity['Role'] || entity['role'],
            // Status: entity[AppConstants.CLAIMS.Status],
            // Active: entity[AppConstants.CLAIMS.Active],
            //Nationality : !Utils.IsNullOrWhiteSpace(entity[AppConstants.CLAIMS.Nationality]) ? entity[AppConstants.CLAIMS.Nationality] :  this._user?.Nationality
        });



        // this._user = new User({
        //     Id: entity[AppConstants.CLAIMS.ID],
        //     FullName: entity[AppConstants.CLAIMS.FullName],
        //     EmailAddress: entity[AppConstants.CLAIMS.EmailAddress],
        //     MobilePhone: entity[AppConstants.CLAIMS.MobilePhone],
        //     QID: entity[AppConstants.CLAIMS.NameIdentifier],
        //     BirthDate: entity[AppConstants.CLAIMS.BirthDate],
        //     Gender: entity[AppConstants.CLAIMS.Gender],
        //     Status: entity[AppConstants.CLAIMS.Status],
        //     Active: entity[AppConstants.CLAIMS.Active],
        //     //Nationality : !Utils.IsNullOrWhiteSpace(entity[AppConstants.CLAIMS.Nationality]) ? entity[AppConstants.CLAIMS.Nationality] :  this._user?.Nationality
        // });

        // if ( !Utils.IsNullOrWhiteSpace(entity[AppConstants.CLAIMS.Nationality]) ){
        //     console.log("change nationality" , entity[AppConstants.CLAIMS.Nationality])
        //     this._user.Nationality = entity[AppConstants.CLAIMS.Nationality];
        // }

        // don't forget to remove this code after amr returns AccountId in Token.
        // if ( Utils.IsNullOrWhiteSpace(this._user.Id) ){
        //     this._user.Id = "4deb17a5-7c5b-ee11-be6e-000d3aabcd84";
        // }

    }

    
    private initializeToken(token: string) {
        this._token = token;
    }
    private initializeUser() {
        let decodedToken = this._jwtHelper.decodeToken(this._token ?? "");
        this.mapTokenToUser(decodedToken);
    }
    private saveInLocalStorage() {
        localStorage.setItem('QNBNToken', this._token ?? "");
        localStorage.setItem('QNBNRefreshToken', this._refreshToken ?? "");
    }
    //#endregion

    //#region public actions
    // public isUserAuthenticated() {
    //     return !Utils.IsNullOrUndefined(this._token) && !Utils.IsNullOrUndefined(this._user) && !this._jwtHelper.isTokenExpired(this._token) && !Utils.IsNullOrWhiteSpace(this._user.Id);
    // }
    public handleValidAuthentication(response: any) {
        this.initializeToken(response.data.token);
        this._refreshToken = response.data.refreshToken || response.data.RefreshToken || this._refreshToken;
        this.initializeUser();
        this.saveInLocalStorage();
        
        // Check for active meetings after login will be handled in app.component
        // via NavigationEnd event to avoid circular dependency issues
    }
    public initializeFromLocalStorage() {
        let storedToken = localStorage.getItem('QNBNToken');
        if(storedToken) {
            this.initializeToken(storedToken);
            this._refreshToken = localStorage.getItem('QNBNRefreshToken') || '';
            this.initializeUser();
        }
    }
    public setAccountId(id: string) {
        if(this.user) this.user.Id = id;
    }
    public logout() {
        this._token = "";
        this._user = null;
        
        // Save sidebar configuration before clearing localStorage
        const sidebarState = localStorage.getItem('sidebarExpandedState');
        
        // Clear token specifically and all localStorage
        localStorage.removeItem('QNBNToken');
        localStorage.removeItem('QNBNRefreshToken');
        localStorage.clear();
        
        // Restore sidebar configuration after clearing
        if (sidebarState !== null) {
            localStorage.setItem('sidebarExpandedState', sidebarState);
        }

        this.clearMicrosoftAuthCache();
    }

    private clearMicrosoftAuthCache(): void {
        Object.keys(localStorage)
            .filter(key => key.toLowerCase().includes('msal'))
            .forEach(key => localStorage.removeItem(key));
        Object.keys(sessionStorage)
            .filter(key => key.toLowerCase().includes('msal') || key === 'msal_return_url')
            .forEach(key => sessionStorage.removeItem(key));
    }
    //#endregion

    
}
